module.exports = __webpack_public_path__ + "img/pay-icon-11.7fd05527.png";